module.exports = __webpack_public_path__ + "static/img/14000278.6576d527.png";